import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'
import InputLabel from '@mui/material/InputLabel'

const PREFIX = 'UnitsSelectContainer'
const classes = {
  main: `${PREFIX}`,
}

const Container = styled('div')({})

export default function UnitsSelect(props) {
  const { id, handler, val, items, label } = props
  const labelId = `${id}-label`

  const onChange = event => {
    handler(event.target.value)
  }

  return (
    <Container className={classes.main}>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          id={id}
          value={val}
          onChange={onChange}
          label={label}
        >
          {items.map(unitsItem => {
            return (
              <MenuItem dense key={unitsItem} value={unitsItem}>
                {unitsItem}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </Container>
  )
}
